import '@babel/polyfill';
import './polyfill';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import store, { history } from './store';
import App from './App';
import * as serviceWorker from './serviceWorker';
import flatpickr from 'flatpickr';
import { Japanese } from 'flatpickr/dist/l10n/ja.js';
import smoothscroll from 'smoothscroll-polyfill';

// Polyfill for IE11
import 'picturefill';
import 'picturefill/dist/plugins/mutation/pf.mutation.min';

import 'sanitize.css/sanitize.css';
import 'font-awesome/css/font-awesome.css';
import 'react-image-gallery/styles/css/image-gallery.css';
import './index.css';

flatpickr.localize(Japanese);
smoothscroll.polyfill();

// GMO トークン取得モジュールの読み込み
const script = document.createElement('script');
script.src = process.env.REACT_APP_GET_TOKEN_URL;
document.body.appendChild(script);

// Aerosmithの読み込み
window.aerosmith = undefined
const cardCheckScript = document.createElement('script');
cardCheckScript.src = process.env.REACT_APP_CARD_ILLEGAL_CHECK_URL;
document.body.appendChild(cardCheckScript);

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();



// WEBPACK FOOTER //
// ./src/index.js